import { Button, Grid } from "@material-ui/core";
import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./genai.css";

export default function PromptEngDepartment() {
  const [genaiaccess, setgenaiaccess] = useState(false);
  //email summary generation
  //data analytics
  //custom chatbot

  /*
    email summary generation: 
      take 3 inputs from user(textfield) :1.openai api key 2.personal email id 3.app password key
      add help icon on input 1 and 3
      add generate summary report button with progress bar
      add view result section and download result button

      data analytics:
      inputs: 1.openai api key 2.dataset link field / link upload 
      generate result Button
      result section:
      heading show model id
      create chatbox like chatgpt 

      custom chatbot:
      inputs: 1.openai api key 2.website link field 
      add plus button to create extra website link fields upto 5 fields
      add minus button to remove fields
      add swal popup for remove button
      add generate button
      result section:
      heading show model id
      create chatbox like chatgpt 
  */
  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to="/feedback-coach">
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              Generative AI for Diversity and Inclusivity
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div>
          <div className="exp-container" style={{ width: "90vw" }}>
            {/* <div className="exp">
              <h2>Drafting & Refining Emails</h2>
              <img
                className="exp-img"
                src="./assets/images/manager-feedback.jpg"
              />
              <Link to="/prompt-chatbot">
                <p>Open</p>
              </Link>
            </div> */}
            {/* <div className="exp">
              <h2>Writing Job Description</h2>
              <img className="exp-img" src="./assets/images/team-meeting.jpg" />
              <Link to="/prompt-eng-jd">
                <p>Open</p>
              </Link>
            </div> */}
            <div className="exp">
              <h2>
                Drafting & Refining <br /> Emails
              </h2>
              <img className="exp-img" src="./assets/images/email-cot1.jpg" />
              <Link to="/prompt-email-cot">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>Feedback Note Generation</h2>
              <img className="exp-img" src="./assets/images/jd-cot.jpg" />
              <Link to="/prompt-job-cot">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>Meeting Agenda Generation</h2>
              <img
                className="exp-img"
                src="./assets/images/meeting-agendas1.jpg"
              />
              <Link to="/prompt-meeting-agendas">
                <p>Open</p>
              </Link>
            </div>
          </div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp">
              <h2>Conflict Resolution</h2>
              <img
                className="exp-img"
                src="./assets/images/manager-feedback.jpg"
              />
              <Link to="/conflict-resolution">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>
                Time management and <br /> prioritization
              </h2>
              <img className="exp-img" src="./assets/images/team-meeting.jpg" />
              <Link to="/time-management">
                <p>Open</p>
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
